var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'mobx-react';
import { configure } from "mobx";
import rootStore from './root-store';
import CustomFieldsPanel from './custom-fields/custom-fields-panel';
import './styles/fonts.css';
import './styles/sass/index.scss';
import './styles/sass/claims.scss';
import './styles/sass/addresses.scss';
import './styles/sass/video-gallery.scss';
import './styles/sass/organization-groups.scss';
import ClaimList from './claims/claims-list';
import AddressBookList from './address-book/address-book-list';
import VideoGallery from './recording/video-gallery';
import WorkflowWizard from './offline-mode/client/workflow-wizard';
import OrganizationGroups from './organization/group/organization-group';
configure({
    enforceActions: "always",
});
var reactAppRoot = document.getElementById('reactapp-root');
if (reactAppRoot) {
    ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, caseTypesStore: rootStore.caseTypesStore, fieldsStore: rootStore.fieldsStore, languageStore: rootStore.languageStore, claimsStore: rootStore.claimsStore, addressBookStore: rootStore.addressBookStore, signingStore: rootStore.signingStore, workflowStore: rootStore.workflowStore, organizationGroupStore: rootStore.organizationGroupStore }, { children: _jsx(App, {}, void 0) }), void 0) }, void 0), document.getElementById('reactapp-root'));
}
var wnd = window;
wnd.renderClaims = function (id) {
    var claimsBox = document.getElementById(id);
    if (claimsBox) {
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, claimsStore: rootStore.claimsStore, languageStore: rootStore.languageStore, addressBookStore: rootStore.addressBookStore }, { children: _jsx(ClaimList, {}, void 0) }), void 0) }, void 0), claimsBox);
    }
};
wnd.renderAddressBook = function (id) {
    var box = document.getElementById(id);
    if (box) {
        box.style.width = "100%";
        box.style.height = "100%";
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, languageStore: rootStore.languageStore, addressBookStore: rootStore.addressBookStore }, { children: _jsx(AddressBookList, {}, void 0) }), void 0) }, void 0), box);
    }
};
wnd.renderOrganizationGroups = function (id, organizationId) {
    var box = document.getElementById(id);
    if (box) {
        box.style.width = "100%";
        box.style.height = "100%";
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, languageStore: rootStore.languageStore, organizationGroupStore: rootStore.organizationGroupStore }, { children: _jsx(OrganizationGroups, { organizationId: organizationId }, void 0) }), void 0) }, void 0), box);
    }
};
wnd.renderWorkflowWizard = function (id) {
    var box = document.getElementById(id);
    if (box) {
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, languageStore: rootStore.languageStore, workflowStore: rootStore.workflowStore }, { children: _jsx(WorkflowWizard, {}, void 0) }), void 0) }, void 0), box);
    }
};
wnd.renderVideoGallery = function (id) {
    var box = document.getElementById(id);
    if (box) {
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, languageStore: rootStore.languageStore, recordingStore: rootStore.recordingStore }, { children: _jsx(VideoGallery, {}, void 0) }), void 0) }, void 0), box);
    }
};
wnd.renderCustomFields = function (id, enableCaseTypeSelection, enableAddressSelection) {
    if (enableCaseTypeSelection === undefined) {
        enableCaseTypeSelection = false;
    }
    if (enableAddressSelection === undefined) {
        enableAddressSelection = true;
    }
    var fieldsRoot = document.getElementById(id);
    if (fieldsRoot) {
        ReactDOM.render(_jsx(React.Fragment, { children: _jsx(Provider, __assign({ rootStore: rootStore, caseTypesStore: rootStore.caseTypesStore, fieldsStore: rootStore.fieldsStore, languageStore: rootStore.languageStore }, { children: _jsx(CustomFieldsPanel, { isEditMode: false, isCaseTypeSelectorHidden: !enableCaseTypeSelection, isAddressSelectionEnabled: enableAddressSelection }, void 0) }), void 0) }, void 0), fieldsRoot);
    }
};
